import { dotsPlot, numberInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { parabolicSarAt } from "../math/parabolicSar";

/**
 * Parabolic SAR (research §1.4), as TV Parabolic SAR with start =
 * increment = Acceleration and maximum = Max (math/parabolicSar.js).
 */
export default {
  id: "parabolic-sar",
  name: "Parabolic SAR",
  isOscillator: false,
  inputs: [
    numberInput("acceleration", "Acceleration", 0.02, { step: 0.01 }),
    numberInput("maximum", "Max", 0.2, { step: 0.01 }),
  ],
  plots: [
    dotsPlot("value", "Points", PALETTE.LIME),
  ],
  buffers: ["trend", "factor", "extreme"],
  levels: [],

  calculate: (bars, { acceleration, maximum }, series, fromIndex) => {
    const settings = { start: acceleration, increment: acceleration, maximum };
    const state = { trend: series.trend, factor: series.factor, extreme: series.extreme, sar: series.value };

    for (let index = fromIndex; index < bars.length; index += 1) parabolicSarAt(bars, index, settings, state);
  },
};
